import vIsEmail from 'validator/lib/isEmail';

export const required = value => (value ? undefined : 'Required');
export const isEmail = value =>
  value && vIsEmail(value) ? undefined : 'Invalid email address';
export const minLength = length => val => {
  if (val && val.length < length) {
    return `Must be ${length} characters or more`;
  }
  return undefined;
};
export const maxLength = length => val => {
  if (val && val.length > length) {
    return `Must be ${length} characters or less`;
  }
  return undefined;
};

export default {
  required,
  isEmail,
  minLength,
  maxLength,
};
